var styleDataHash = "1d09aed9";
const injectCss = () => {
  var css = `.ZNa1L{height:18px;position:relative;width:18px}.G9JdS,._3xjxb{height:100%;position:absolute;top:0;width:100%;fill:none;stroke-linecap:round}[dir=ltr] .G9JdS,[dir=ltr] ._3xjxb{left:0}[dir=rtl] .G9JdS,[dir=rtl] ._3xjxb{right:0}._3xjxb{stroke:currentColor;opacity:.3}[dir=ltr] ._3xjxb{animation:INFch 666ms linear infinite}[dir=rtl] ._3xjxb{animation:CVqYt 666ms linear infinite}.G9JdS{stroke:currentColor}[dir=ltr] .G9JdS{animation:INFch 2s linear infinite}[dir=rtl] .G9JdS{animation:CVqYt 2s linear infinite}@keyframes INFch{to{transform:rotate(1turn)}}@keyframes CVqYt{to{transform:rotate(-1turn)}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var double_loader_default = {
  "wrapper": "ZNa1L",
  "top": "_3xjxb",
  "bottom": "G9JdS",
  "rotation-ltr": "INFch",
  "rotation-rtl": "CVqYt"
};
export {
  double_loader_default as default,
  injectCss
};
//# sourceMappingURL=double-loader-scss.js.map
